<template>
  <div>
    <label
      :class="['inputswitch',
               disabled? 'toggle-disabled':'',
               focused? 'focus': '']"
    >
      <input
        v-bind="{ ...$attrs}"
        :id="inputId"
        ref="input"
        class="input-hide"
        type="checkbox"
        role="switch"
        :checked="checked"
        :disabled="disabled"
        :aria-checked="checked"
        :aria-labelledby="ariaLabelledby"
        :aria-label="ariaLabel"
        @click="onClick($event)"
        @focus="onFocus($event)"
        @blur="onBlur($event)"
      >
      <span class="state">
        <span class="container">
          <span class="position" />
        </span>
      </span>
      <div>
        <slot />
      </div>
    </label>
  </div>
</template>

<script>
export default {
  name: 'Toggle',
  props: {
    modelValue: {
      type: null,
      default: false,
    },
    trueValue: {
      type: null,
      default: true,
    },
    falseValue: {
      type: null,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    inputId: {
      type: String,
      default: null,
    },
    ariaLabelledby: {
      type: String,
      default: null,
    },
    ariaLabel: {
      type: String,
      default: null,
    },
  },
  emits: ['click', 'update:modelValue', 'change', 'input', 'focus', 'blur'],
  data() {
    return {
      focused: false,
    };
  },
  computed: {
    checked() {
      return this.modelValue === this.trueValue;
    },
  },
  methods: {
    onClick(event) {
      if (!this.disabled) {
        const newValue = this.checked ? this.falseValue : this.trueValue;
        this.$emit('click', event);
        this.$emit('update:modelValue', newValue);
        this.$emit('change', event);
        this.$emit('input', newValue);
        this.$refs.input.focus();
      }
    },
    onFocus(event) {
      this.focused = true;
      this.$emit('focus', event);
    },
    onBlur(event) {
      this.focused = false;
      this.$emit('blur', event);
    },
  },
};
</script>

<style lang="scss" scoped>
.inputswitch {
  display: flex;
  align-items: center;
  position: relative;
  user-select: none;
}
.input-hide {
  position: absolute;
  left: rem-calc(10);
  bottom: rem-calc(10);
}

label input[role="switch"] {
  opacity: 0;
}

label input[role="switch"] ~ .state {
  display: flex;
  user-select: none;
}

label input[role="switch"] ~ .state > .container {
  position: relative;
  display: inline-block;
  width: rem-calc(51);
  height: rem-calc(31);
  border-radius: rem-calc(30);
  border: rem-calc(1) solid transparent;
  transition: background-color 0.2s, color 0.2s, border-color 0.2s,
  box-shadow 0.2s;
}

label input[role="switch"] ~ .state > .container > .position {
  position: relative;
  display: inline-block;
  margin: rem-calc(0.92);
  border-radius: 50%;
  width: rem-calc(27);
  height: rem-calc(27);
  background:$white;
  transition-duration: 0.2s;
}

label input[role="switch"]:not(:checked) ~ .state span.on {
  display: none;
}

label input[role="switch"]:checked ~ .state > span.off {
  display: none;
}

label input[role="switch"]:checked ~ .state > .container > .position {
  transform: translateX(1.25rem);
  border-color: $white;
  background: $white;
}
label input[role="switch"]:checked ~ .state > .container {
  border-color: $black;
  background:  $black;
}
label.focus,
label:hover {
  cursor: pointer;
}
input {
  transform: scale(0);
}
label.focus span.container,
label:hover span.container {
  background-color: $white;
  outline-offset: rem-calc(2);
  outline: auto;
  outline:-webkit-focus-ring-color solid rem-calc(2);
}
.toggle-disabled {
  cursor: default;
  pointer-events: none;
  user-select: none;
}
</style>

<style lang="scss" brand="mcom" scoped>
label input[role="switch"] ~ .state > .container {
  background: $gray-4-color;
}
</style>

<style lang="scss" brand="bcom" scoped>
label input[role="switch"] ~ .state > .container {
  background: $gray-3-color;
}
</style>
